import { render, staticRenderFns } from "./DateMatchmaking.vue?vue&type=template&id=47c4c12a&scoped=true"
import script from "./DateMatchmaking.vue?vue&type=script&lang=js"
export * from "./DateMatchmaking.vue?vue&type=script&lang=js"
import style0 from "./DateMatchmaking.vue?vue&type=style&index=0&id=47c4c12a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c4c12a",
  null
  
)

export default component.exports